import { Paper, Typography } from '@material-ui/core';
import { unstable_Box as Box } from '@material-ui/core/Box';
import { withStyles } from '@material-ui/core/styles';
import React from 'react';
import { connect } from 'react-redux';

import { Booking } from '@aps-management/primapp-common';

import { Alert, Incrementer } from '_components/elements';

/* */
const styles = (theme) => ({
  paper: {
    marginTop: theme.spacing.unit * 3,
    paddingLeft: theme.spacing.unit * 2,
    paddingRight: theme.spacing.unit * 2,
  },
  itemContainer: {
    alignItems: 'center',
    borderBottom: `1px solid ${theme.palette.grey[300]}`,
    display: 'flex',
    flexDirection: 'row',
    paddingBottom: theme.spacing.unit * 2,
    paddingTop: theme.spacing.unit * 2,
  },
  itemName: {
    flex: 1,
    paddingRight: theme.spacing.unit * 2,
  },
});

/* */
class SetAccessories extends React.Component {
  /* */
  handleIncrease = (idx) => {
    const { data, addAccessory } = this.props;

    return async () =>
      addAccessory({
        id: data.accessories[idx].id,
        name: data.accessories[idx].name,
      });
  };

  /* */
  handleDecrease = (idx) => {
    const { data, removeAccessory } = this.props;

    return async () =>
      removeAccessory({
        id: data.accessories[idx].id,
      });
  };

  /* */
  renderAlert() {
    const { search } = this.props;

    const playersQty = search.players.length;
    const accessoriesQty = search.accessoriesTotalQty;

    if (accessoriesQty > playersQty) {
      return <Alert variant='error'>{'Vous avez dépassé la quantité maximum autorisée (1 par joueur).'}</Alert>;
    }

    return null;
  }

  /* */
  render() {
    const { classes, data, search } = this.props;

    return (
      <Box m={1} mb={3}>
        <Typography paragraph component='p' variant='h6'>
          {'Quel(s) accessoire(s) ?'}
        </Typography>
        {this.renderAlert()}
        <Paper className={classes.paper}>
          {data.accessories.map((acc, key) => {
            const { qty } = search.accessories[acc.id] || { qty: 0 };

            return (
              <div className={classes.itemContainer} key={key}>
                <Typography className={classes.itemName} component='span' variant='subtitle1'>
                  {acc.name}
                </Typography>
                <Incrementer
                  size='small'
                  value={qty}
                  minValue={0}
                  maxValue={acc.max}
                  onDecrease={this.handleDecrease(key)}
                  onIncrease={this.handleIncrease(key)}
                />
              </div>
            );
          })}
        </Paper>
      </Box>
    );
  }
}

const mapStateToProps = ({ bookingData, bookingSearch }) => ({ data: bookingData, search: bookingSearch });

const StyledComponent = withStyles(styles)(SetAccessories);

export default connect(mapStateToProps, Booking.actions)(StyledComponent);
